/** @jsxImportSource @emotion/react */
import { faBarcodeRead, faPlus } from "@fortawesome/pro-regular-svg-icons";
import { ButtonProps } from "reactstrap";
import { CreateLayer } from "./Layer/CreateLayer";
import { useLayerModal } from "../../../hooks";
import { Button } from "../../Helper/Button";

export default function ScanLayerButton({ modal, label, onClick, initialCheckType, ...buttonProps }: { modal?: boolean; label?: string; onClick?(): void; initialCheckType?: string; } & ButtonProps) {
    const {
        layerModalOpen,
        setLayerModal,
        onCreateLayer,
        setValue,
        onClose,
        setLayerSelect,
        layerConfig,
        layer,
        useBarcodeScanner
    } = useLayerModal();

    if (!layerConfig) {
        return null;
    }
    return (
        <>
            <CreateLayer
                modal={modal}
                isOpen={!modal ? { withScanner: true } : layerModalOpen}
                onClose={onClose}
                onSubmit={onCreateLayer}
                layer={layer}
                setLayerSelect={setLayerSelect}
                setValue={setValue}
                disableSaveButton={!layer.label || !layer.type}
                layerConfig={layerConfig}
                initialCheckType={initialCheckType}
            />

            {modal && (
                <div className="d-flex align-items-center justify-content-between justify-content-lg-start">
                    {useBarcodeScanner ? (
                        <Button
                            color="primary"
                            className="text-nowrap fs-5 d-flex align-items-center gap-2"
                            onClick={() => {
                                if (onClick) onClick();

                                setLayerModal({ withScanner: true });
                            }}
                            icon={faBarcodeRead}
                            {...buttonProps}
                        >
                            {label ?? "Perform check"}
                        </Button>
                    ) : (
                        <Button
                            color="primary"
                            className="text-nowrap"
                            onClick={() => {
                                if (onClick) onClick();

                                setLayerModal({ withScanner: false });
                            }}
                            icon={faPlus}
                            {...buttonProps}

                        >
                            {label}
                        </Button>
                    )}
                </div>
            )}
        </>
    );
}
